// src/utils/unreadBus.js
export const emitUnreadChanged = (payload = {}) => {
  window.dispatchEvent(new CustomEvent('unread-changed', { detail: payload }));
};

export const onUnreadChanged = (cb) => {
  const handler = (e) => cb?.(e.detail);
  window.addEventListener('unread-changed', handler);
  return () => window.removeEventListener('unread-changed', handler);
};
